import {
    type GetUploadTokenForNewsPhotoResponseType,
    type GetUploadTokenForNewsPhotoRequestType
} from "./type";
import {
    request
} from "../request";

const getUploadTokenForNewsPhoto = async (params: GetUploadTokenForNewsPhotoRequestType): Promise<GetUploadTokenForNewsPhotoResponseType> => {
    return await request<GetUploadTokenForNewsPhotoResponseType>("/news/getUploadTokenForNewsPhoto", {
        body: JSON.stringify(params),
        method: "POST"
    });
};
export default getUploadTokenForNewsPhoto;
